/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ContractStatusEnum = {
    Draft: 'Draft',
    ForActivation: 'For activation',
    Active: 'Active',
    Terminated: 'Terminated',
    SubmittedToErpEso: 'Submitted to ERP/ESO',
    ConfirmedByErpEso: 'Confirmed by ERP/ESO',
    Signed: 'Signed',
    RejectedByErp: 'Rejected by ERP',
    GeneratedContract: 'Generated Contract',
    RejectedByCustomer: 'Rejected by Customer',
    Renewed: 'Renewed',
    WaitingForConnection: 'Waiting for Connection',
    Canceled: 'Canceled',
    WaitingForValidation: 'Waiting for Validation'
};
/**
 * Check if a given object implements the Contract interface.
 */
export function instanceOfContract(value) {
    if (!('startDate' in value) || value['startDate'] === undefined)
        return false;
    if (!('endDate' in value) || value['endDate'] === undefined)
        return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('contractNumber' in value) || value['contractNumber'] === undefined)
        return false;
    if (!('contractType' in value) || value['contractType'] === undefined)
        return false;
    if (!('customerName' in value) || value['customerName'] === undefined)
        return false;
    return true;
}
export function ContractFromJSON(json) {
    return ContractFromJSONTyped(json, false);
}
export function ContractFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startDate': (json['start_date'] == null ? null : new Date(json['start_date'])),
        'endDate': (json['end_date'] == null ? null : new Date(json['end_date'])),
        'createdDate': (new Date(json['created_date'])),
        'status': json['status'],
        'contractNumber': json['contract_number'],
        'contractType': json['contract_type'],
        'customerName': json['customer_name'],
        'meteringPointsCount': json['metering_points_count'] == null ? undefined : json['metering_points_count'],
    };
}
export function ContractToJSON(json) {
    return ContractToJSONTyped(json, false);
}
export function ContractToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'start_date': (value['startDate'].toISOString().substring(0, 10)),
        'end_date': (value['endDate'].toISOString().substring(0, 10)),
        'created_date': ((value['createdDate']).toISOString().substring(0, 10)),
        'status': value['status'],
        'contract_number': value['contractNumber'],
        'contract_type': value['contractType'],
        'customer_name': value['customerName'],
        'metering_points_count': value['meteringPointsCount'],
    };
}
